import React from 'react';
import { useTranslation } from 'react-i18next';

const CharactersOriginalHeader = () => {
    const { t } = useTranslation();

    return (
        <div className="mb-12">
            {/* HERO BANNER - STAGE / STARS ESTHETIC */}
            <div className="relative overflow-hidden rounded-3xl bg-white dark:bg-gray-900 shadow-xl dark:shadow-2xl border border-gray-200 dark:border-gray-800 group transition-colors duration-300">
                {/* 1. Glow backgrounds (Amber/Gold for Stage/Stars) */}
                <div className="absolute -top-24 -right-24 w-96 h-96 bg-amber-500/10 dark:bg-amber-500/20 rounded-full blur-3xl mix-blend-screen group-hover:bg-amber-400/20 dark:group-hover:bg-amber-400/30 transition-all duration-1000"></div>
                <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-yellow-500/10 dark:bg-yellow-500/20 rounded-full blur-3xl mix-blend-screen group-hover:bg-yellow-400/20 dark:group-hover:bg-yellow-400/30 transition-all duration-1000"></div>

                {/* 2. Grid texture overlay (Roster Vibe) */}
                <div className="absolute inset-0 bg-[linear-gradient(rgba(0,0,0,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,0.03)_1px,transparent_1px)] dark:bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:32px_32px] [mask-image:radial-gradient(ellipse_at_center,black_40%,transparent_100%)]"></div>

                <div className="relative z-10 px-8 py-12 md:p-14 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
                    <div className="flex-1 relative">

                        {/* 3. Decorative status tag (Star Cast Indicator) */}
                        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-amber-50 dark:bg-amber-500/10 border border-amber-200 dark:border-amber-500/20 text-amber-700 dark:text-amber-400 text-xs font-mono font-bold tracking-widest uppercase mb-4 shadow-sm dark:shadow-inner transition-colors duration-300">
                            <span className="relative flex h-2 w-2">
                                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-amber-400 opacity-75"></span>
                                <span className="relative inline-flex rounded-full h-2 w-2 bg-amber-500"></span>
                            </span>
                            Superstars Roster
                        </div>

                        {/* 4. Title Gradient */}
                        <h1 className="text-5xl md:text-7xl font-black text-transparent bg-clip-text bg-gradient-to-br from-amber-600 via-yellow-500 to-orange-400 dark:from-white dark:via-amber-100 dark:to-yellow-500 tracking-tighter mb-4 drop-shadow-sm select-none transition-colors duration-300">
                            {t('CharactersOriginal.title')}
                        </h1>

                        {/* 5. Subtitle with accent border */}
                        <p className="text-lg md:text-xl text-gray-600 dark:text-gray-400 font-light max-w-2xl leading-relaxed border-l-2 border-amber-500/50 pl-4 transition-colors duration-300">
                            {t('CharactersOriginal.subtitle')}
                        </p>
                    </div>

                    {/* 6. Abstract graphical element (Stage Lights / Star) */}
                    <div className="hidden lg:flex items-center justify-center relative w-40 h-40 shrink-0 select-none pointer-events-none">
                        {/* Rotating Star Ring */}
                        <div className="absolute inset-0 border-[1px] border-amber-400/20 rounded-full animate-[spin_20s_linear_infinite]"></div>

                        {/* Inner Dashed Ring */}
                        <div className="absolute inset-4 border-[2px] border-dashed border-yellow-500/30 rounded-full animate-[spin_15s_linear_infinite_reverse]"></div>

                        {/* Center Stage Lights */}
                        <div className="absolute inset-0 bg-[conic-gradient(from_0deg,transparent_0deg,rgba(251,191,36,0.1)_20deg,transparent_40deg,rgba(251,191,36,0.1)_60deg,transparent_80deg,rgba(251,191,36,0.1)_100deg,transparent_120deg)] animate-[spin_30s_linear_infinite_reverse] rounded-full mix-blend-screen"></div>

                        {/* Center Gem (Golden Ticket) */}
                        <div className="w-16 h-16 bg-gradient-to-br from-yellow-300 to-amber-500 dark:from-amber-400 dark:to-orange-500 rounded-lg shadow-[0_0_40px_rgba(251,191,36,0.4)] rotate-12 group-hover:rotate-[36deg] transition-transform duration-1000 ease-in-out mix-blend-screen overflow-hidden flex items-center justify-center">
                            <div className="w-4 h-full bg-white/20 -skew-x-12 translate-x-4"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CharactersOriginalHeader;
